import { GUIDE_PAGE_ASSETS } from "./guideAssets";

const GUIDE_TYPES = ["bcfw", "cjly", "gnly", "qydz", "qzbl", "srdz"];

export function getGuidePage(type, i18n) {
  if (!GUIDE_TYPES.includes(type)) return null;

  const assets = GUIDE_PAGE_ASSETS[type];
  const locale = i18n.messages[i18n.locale]?.guide?.[type];
  if (!assets || !locale) return null;

  return {
    heroImg: assets.hero,
    gallery: assets.gallery,
    heroBannerTitle: i18n.t(`nav.${type}`),
    en: locale.en || "",
    title: locale.title || "",
    paragraphs: locale.paragraphs || [],
  };
}
